import { fetchWithAuth } from '../utils/apiUtils';

export default class AlertService {
  private static alertPath = 'job/alerts';

  public static async searchAlert({
    deviceId,
    siteId,
    jobId,
  }: { deviceId?: string; siteId?: string; jobId?: string }) {
    return await fetchWithAuth(`${this.alertPath}/search`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...(siteId ? { siteId } : {}),
        ...(deviceId ? { deviceId } : {}),
        ...(jobId ? { jobId } : {}),
      }),
    });
  }

  public static async getAlertById(alertId: string) {
    return await fetchWithAuth(`${this.alertPath}/${alertId}`, {
      method: 'GET',
    });
  }
}
